import { render, staticRenderFns } from "./WineDetails.vue?vue&type=template&id=b45061a2"
import script from "./WineDetails.vue?vue&type=script&lang=js"
export * from "./WineDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b45061a2')) {
      api.createRecord('b45061a2', component.options)
    } else {
      api.reload('b45061a2', component.options)
    }
    module.hot.accept("./WineDetails.vue?vue&type=template&id=b45061a2", function () {
      api.rerender('b45061a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/WineDetails.vue"
export default component.exports